import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Breadcrumbs } from 'js/components/design-system';
import { staffBreadcrumbsHistory } from './functions';

const StaffBreadcrumbs = () => {
  const location = useLocation();
  const { t } = useTranslation();
  return (
    <Breadcrumbs
      className="lawyer-type-breadcrumbs"
      history={staffBreadcrumbsHistory(t, location)}
    />
  );
};

export default StaffBreadcrumbs;
